"use strict";

import angular from "angular";

/**
 * Cenários no escopo do grupo.
 *
 * A casca é própria (`groupScenariosComponent`): a de Fonte de Dados da empresa leva o usuário por
 * "Importar → Criar Cenário", e no grupo não se importa nada — o dado vem das empresas-membro.
 * Já a tabela de cenário em si é a mesma da empresa, recebendo `groupData` no lugar de
 * `CompanyData`, como em Demonstrações e Customização do grupo.
 *
 * As quatro fontes são as mesmas de Orçamento e Projeção: o grupo tem série própria de Fiscal e de
 * Pessoal — só o consolidado contábil é que é derivado das empresas-membro.
 */
angular
    .module("nucont.accounting.group")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    const lazyLoadScenarioScreens = (transition) => {
        const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
        return import(
            /* webpackChunkName: "feature-accounting-company-department" */ "../../company/department/department.entry"
        ).then(() =>
            $ocLazyLoad.inject("nucont.accounting.company.department")
        );
    };

    /**
     * O cabeçalho lê `data.layoutConfig` do estado de destino da transição. Sem isto, Cenários do
     * grupo abria sem título nenhum — na empresa as telas de cenário ficam sob Fonte de Dados,
     * que já declara o seu bloco, e por isso o problema só aparecia aqui.
     */
    const SCENARIOS_TITLE = {
        layoutConfig: {
            model: "LayoutConfigModel5",
            ignore: { object: "headerConfig", path: "title" },
            setAttrs: [
                {
                    object: "headerConfig",
                    path: "moduleTitle.text",
                    value: "Cenários"
                },
                {
                    object: "headerConfig",
                    path: "moduleTitle.description",
                    value: "Monte cenários alternativos e compare com o resultado realizado."
                },
                {
                    object: "headerConfig",
                    path: "moduleTitle.enabled",
                    value: true
                }
            ]
        }
    };

    $stateProvider
        .state("nucont.accounting.group.scenarios", {
            url: "/cenarios",
            lazyLoad: lazyLoadScenarioScreens,
            views: {
                "admin@nucont.accounting": {
                    component: "groupScenariosComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: SCENARIOS_TITLE,
            bodyClass: "department-module"
        })
        .state("nucont.accounting.group.scenarios.accounting", {
            url: "/contabil/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            views: {
                "scenarioContent@nucont.accounting.group.scenarios": {
                    component: "departmentAccountingScenariosComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: SCENARIOS_TITLE,
            bodyClass: "department-module"
        })
        .state("nucont.accounting.group.scenarios.financial", {
            url: "/financeiro/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            views: {
                "scenarioContent@nucont.accounting.group.scenarios": {
                    component: "departmentFinancialScenariosComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: SCENARIOS_TITLE,
            bodyClass: "department-module"
        })
        .state("nucont.accounting.group.scenarios.tax", {
            url: "/fiscal/:scenarioId?accountsPlanType",
            params: {
                scenarioId: { value: null, dynamic: true },
                accountsPlanType: { value: null, dynamic: true }
            },
            views: {
                "scenarioContent@nucont.accounting.group.scenarios": {
                    component: "departmentTaxScenariosComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: SCENARIOS_TITLE,
            bodyClass: "department-module"
        })
        .state("nucont.accounting.group.scenarios.personnel", {
            url: "/pessoal/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            views: {
                "scenarioContent@nucont.accounting.group.scenarios": {
                    component: "departmentPersonnelScenariosComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: SCENARIOS_TITLE,
            bodyClass: "department-module"
        });
}
